import React from 'react';
import { useHistory } from 'react-router-dom';
import {
    Button,
    Typography,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle
} from '@material-ui/core';
import { ReportProblem } from '@material-ui/icons';
import { useIdleTimer } from 'react-idle-timer';
import moment from 'moment';
import { UserContext } from '../../app';
import './style.css';
import useFetch from '../../services/useFetch';

const defaultTimeout = 20 * 60 * 1000;
const promptTimeout = 5 * 60 * 1000;

const IdleTimer = () => {
    const router = useHistory();
    const { handleLogoutUser } = React.useContext(UserContext);
    const [openModal, setOpenModal] = React.useState(false);
    const [timeRemaining, setTimeRemaining] = React.useState(promptTimeout);
    const { currentUser } = React.useContext(UserContext);
    const [timeout, setTimeout] = React.useState(defaultTimeout);

    const {
        call: sessionTimeoutInMinAPICall,
        data: sessionTimeoutInMinAPIData,
        error: sessionTimeoutInMinAPIError,
    } = useFetch(
        '/V5.0/DeveloperPortal/SessionTimeoutInMin',
        'POST',
        {},
        {},
        {
            DomainName: currentUser?.domainId,
        },
        [],
        { callOnMount: false }
    );

    React.useEffect(() => {
        if (sessionTimeoutInMinAPIData?.sessionTimeoutInMin) {
            const sessionTime = Number(sessionTimeoutInMinAPIData?.sessionTimeoutInMin);
            setTimeout(sessionTime * 60 * 1000);
        }
    }, [sessionTimeoutInMinAPIData]);

    const onPrompt = () => {
        setOpenModal(true);
        setTimeRemaining(promptTimeout);
    };

    const onActive = () => {
        setOpenModal(false);
        setTimeRemaining(0);
    };

    const onIdle = () => {
        setOpenModal(false);       
        setTimeRemaining(0);
        handleLogout();
    };

    const { getRemainingTime, isPrompted, activate } = useIdleTimer({
        timeout,
        promptTimeout,
        onPrompt,
        onActive,
        onIdle
    });

    const handleStayLoggedIn = () => {
        setOpenModal(false);
        activate();
    };

    const handleLogout = () => {
        handleLogoutUser().then(() => {
            setOpenModal(false);
            router.push('/signin');
        });
    };

    React.useEffect(() => {
        if (openModal && timeRemaining <= 0) {
            handleLogout();
        }
    }, [timeRemaining]);

    React.useEffect(() => {
        const interval = setInterval(() => {
            if (isPrompted()) {
                setTimeRemaining(getRemainingTime());
            }
        }, 1000);
        return () => {
            clearInterval(interval);
        }
    }, [getRemainingTime, isPrompted]);

    const getTimer = () => {
        return (
            (moment.duration(timeRemaining).hours() < 10
                ? '0' + moment.duration(timeRemaining).hours()
                : moment.duration(timeRemaining).hours())
            + ':' +
            (moment.duration(timeRemaining).minutes() < 10
                ? '0' + moment.duration(timeRemaining).minutes()
                : moment.duration(timeRemaining).minutes())
            + ':' +
            (moment.duration(timeRemaining).seconds() < 10
                ? '0' + moment.duration(timeRemaining).seconds()
                : moment.duration(timeRemaining).seconds())
        );
    };

    React.useEffect(() => {
        if (currentUser) {
            sessionTimeoutInMinAPICall();
        }
    }, []);

    return (
        <Dialog open={openModal} className="idle-timer">
            <DialogTitle className="title">
                <ReportProblem scale={30} className="error-icon" />
                Inactivity Timer
            </DialogTitle>
            <DialogContent>
                <Typography>
                    Due to inactivity, you will be automatically logged out in <b>{getTimer()}</b>...
                </Typography>
            </DialogContent>
            <DialogActions className="action-buttons">
                <Button className="stay-login-button" onClick={handleStayLoggedIn}>
                    STAY LOGGED IN
                </Button>
                <Button className="logout-button" onClick={handleLogout}>
                    LOG OUT
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default IdleTimer;
